module.exports = __webpack_public_path__ + "static/media/TelBlank.af88c03b.svg";